import { IOptionSelection } from "../../../shared/hooks/options-hooks";

export const setInitialRoles = (role_types: Array<IOptionSelection>, selected_roles: Array<string> | undefined): Array<IOptionSelection> => {
  const result = role_types.map((role: IOptionSelection) => ({
    ...role,
    isSelected: !!selected_roles?.includes(role.value)
  }))

  return result;
}